/* Early access capture. Drives every [data-pp-form] on the page, so the landing
   page hero card and the Store page share one implementation.

   Only handles submission and phone formatting. The landing page's slide-up
   sheet is its own behaviour and stays in that section. */

(function () {
  var init = function (form) {
    if (form.dataset.ppBound) return;
    form.dataset.ppBound = '1';

    var msg = form.querySelector('[data-pp-msg]');
    var say = function (text, isError) {
      if (!msg) return;
      msg.textContent = text;
      msg.hidden = false;
      msg.classList.toggle('pp-lp__msg--err', !!isError);
    };

    // Format US numbers as typed. Anything with a country code other than +1 is
    // left alone so international numbers stay enterable.
    var phoneInput = form.querySelector('[name="phone_number"]');
    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        var raw = phoneInput.value;
        var compact = raw.replace(/[^\d+]/g, '');
        if (/^\+(?!1)/.test(compact)) return;
        var atEnd = phoneInput.selectionStart === raw.length;
        var d = compact.replace(/\D/g, '');
        if (d.charAt(0) === '1') d = d.slice(1);
        d = d.slice(0, 10);
        var out = '';
        if (d.length) {
          out = '+1 (' + d.slice(0, 3);
          if (d.length >= 3) out += ')';
          if (d.length > 3) out += ' ' + d.slice(3, 6);
          if (d.length > 6) out += '-' + d.slice(6, 10);
        }
        phoneInput.value = out;
        if (atEnd) phoneInput.setSelectionRange(out.length, out.length);
      });
    }

    // Klaviyo rejects anything that is not E.164.
    var toE164 = function (raw) {
      var v = (raw || '').trim();
      if (!v) return '';
      if (v.charAt(0) === '+') return v.replace(/[^\d+]/g, '');
      var digits = v.replace(/\D/g, '');
      if (digits.length === 10) return '+1' + digits;
      if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
      return '+' + digits;
    };

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.pp-lp__submit');
      var email = (form.querySelector('[name="email"]') || {}).value || '';
      var name = (form.querySelector('[name="first_name"]') || {}).value || '';
      var smsEl = form.querySelector('[name="sms_consent"]');
      var phone = phoneInput ? toE164(phoneInput.value) : '';
      email = email.trim();
      name = name.trim();

      if (!email || email.indexOf('@') < 1) {
        say('Enter a valid email address.', true);
        return;
      }

      // SMS consent must be explicit. A number without the tick is stored as a
      // profile attribute only, never subscribed.
      var smsOptIn = !!(smsEl && smsEl.checked && phone);

      var attrs = { email: email };
      if (name) attrs.first_name = name;
      if (phone) attrs.phone_number = phone;
      attrs.subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
      if (smsOptIn) attrs.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };

      if (btn) btn.disabled = true;
      say('One moment.', false);

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.dataset.company), {
        method: 'POST',
        // Revision matters. Older revisions reject `subscriptions` as an invalid
        // profile field and every signup 400s behind a generic error.
        headers: { 'content-type': 'application/json', revision: '2026-07-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: form.dataset.source || 'Landing page',
              profile: { data: { type: 'profile', attributes: attrs } }
            },
            relationships: { list: { data: { type: 'list', id: form.dataset.list } } }
          }
        })
      })
        .then(function (res) {
          if (res.status === 202 || res.ok) {
            form.innerHTML = '<p class="pp-lp__msg">' + (form.dataset.success || 'You are on the list.') + '</p>';
          } else {
            if (btn) btn.disabled = false;
            say('That did not go through. Check your details and try again.', true);
          }
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          say('Network problem. Try again in a moment.', true);
        });
    });
  };

  var bindAll = function () {
    document.querySelectorAll('[data-pp-form]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', bindAll);
})();
